<template>
  <div class="mod-video">
    <div class="page-header">
      <span class="page-header__title">视频管理</span>
    </div>

    <div class="page-body">
      <!-- 筛选栏 -->
      <div class="toolbar">
        <el-input
          v-model="dataForm.cartoonName"
          placeholder="搜索视频标题..."
          clearable
          class="toolbar__search"
          @keyup.enter.native="handleSearch">
        </el-input>
        <el-select
          v-model="dataForm.tagId"
          placeholder="全部标签"
          clearable
          filterable
          class="toolbar__select"
          @change="handleSearch">
          <el-option
            v-for="tag in tagList"
            :key="tag.id"
            :label="tag.name"
            :value="tag.id">
          </el-option>
        </el-select>
        <el-select
          v-model="dataForm.status"
          placeholder="全部状态"
          clearable
          class="toolbar__select"
          @change="handleSearch">
          <el-option label="上架" :value="movieStatus.ONLINE"></el-option>
          <el-option label="下架" :value="movieStatus.OFFLINE"></el-option>
        </el-select>
        <el-input
          v-model="dataForm.durationMin"
          type="number"
          min="0"
          placeholder="最小分钟"
          clearable
          style="width: 110px;"
          @keyup.enter.native="handleSearch">
        </el-input>
        <span style="margin: 0 6px; color: #909399;">-</span>
        <el-input
          v-model="dataForm.durationMax"
          type="number"
          min="0"
          placeholder="最大分钟"
          clearable
          style="width: 110px; margin-right: 8px;"
          @keyup.enter.native="handleSearch">
        </el-input>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <div class="toolbar__right">
          <el-button
            :disabled="!selections.length"
            @click="openBatchTagDialog">
            批量设标签
          </el-button>
          <!-- 批量删除、清理用户端缓存暂时隐藏 -->
          <!-- <el-button
            type="danger"
            icon="el-icon-delete"
            :disabled="!selections.length"
            @click="handleDelete()">
            批量删除
          </el-button>
          <el-button icon="el-icon-refresh" @click="handleClearCache">清理用户端缓存</el-button> -->
          <el-button type="primary" icon="el-icon-plus" @click="addOrUpdate()">新增视频</el-button>
        </div>
      </div>

      <!-- 视频列表 -->
      <div class="panel">
        <div class="panel__tip">
          <i class="el-icon-warning-outline"></i>
          排序为示例数据，movies 表暂无该字段
        </div>
        <el-table
          :data="dataList"
          v-loading="loading"
          style="width: 100%;"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column label="封面" width="120">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.cartoonImage"
                :src="scope.row.cartoonImage"
                fit="cover"
                class="cover"
                :preview-src-list="[scope.row.cartoonImage]">
              </el-image>
              <div v-else class="cover cover--empty">无封面</div>
            </template>
          </el-table-column>
          <el-table-column label="标题" min-width="260">
            <template slot-scope="scope">
              <div class="title">{{ scope.row.cartoonName }}</div>
              <div class="title__sub">ID: {{ scope.row.cartoonCode }}</div>
            </template>
          </el-table-column>
          <el-table-column label="标签" min-width="240">
            <template slot-scope="scope">
              <el-tag
                v-for="tag in scope.row.tags"
                :key="tag.id"
                size="mini"
                type="info"
                effect="plain"
                class="tag-item">
                {{ tag.name }}
              </el-tag>
              <el-button type="text" size="mini" @click="openTagDialog(scope.row)">
                {{ scope.row.tags.length ? '修改' : '添加' }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="VIP" width="80">
            <template slot-scope="scope">
              <el-tag :type="scope.row.cartoonVip === vipType.PAID ? 'warning' : 'info'" size="small">
                {{ scope.row.cartoonVip === vipType.PAID ? '是' : '否' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="cartoonHot" label="热度" width="100">
            <template slot-scope="scope">{{ scope.row.cartoonHot || 0 }}</template>
          </el-table-column>
          <el-table-column label="单集价格" width="110">
            <template slot-scope="scope">{{ scope.row.onePrice || 0 }}</template>
          </el-table-column>
          <el-table-column label="时长" width="90" align="center">
            <template slot-scope="scope">{{ scope.row.vodDuration || '-' }}</template>
          </el-table-column>
          <el-table-column label="排序" width="90">
            <template slot-scope="scope">{{ scope.row.sort }}</template>
          </el-table-column>
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="isOnline(scope.row) ? 'success' : 'info'" size="small">
                {{ isOnline(scope.row) ? '上架' : '下架' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160" fixed="right">
            <template slot-scope="scope">
              <!-- 分集功能暂时下线 -->
              <!-- <el-button type="text" size="small" @click="handleViewEpisodes(scope.row)">分集</el-button> -->
              <el-button type="text" size="small" @click="addOrUpdate(scope.row.cartoonCode)">编辑</el-button>
              <el-button type="text" size="small" @click="handleToggleOnline(scope.row)">
                {{ isOnline(scope.row) ? '下架' : '上架' }}
              </el-button>
              <el-button type="text" size="small" class="danger-text" @click="handleDelete(scope.row.cartoonCode)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handlePageChange">
        </el-pagination>
      </div>
    </div>

    <!-- 弹窗：新增 / 修改视频（复用影视模块） -->
    <add-or-update v-if="dialogVisible" ref="addOrUpdate" @refreshDataList="loadList"></add-or-update>

    <!-- 弹窗：设置标签（单个 / 批量共用） -->
    <el-dialog
      :visible.sync="tagDialogVisible"
      :title="tagDialogBatch ? `批量设置标签（已选 ${selections.length} 个视频）` : '设置标签'"
      width="520px"
      :close-on-click-modal="false">
      <div v-if="!tagDialogBatch" class="tag-dialog__movie">{{ tagDialogMovieName }}</div>
      <el-select
        v-model="tagDialogIds"
        multiple
        filterable
        placeholder="请选择标签，最多 3 个"
        style="width: 100%;"
        :multiple-limit="maxTags">
        <el-option
          v-for="tag in tagList"
          :key="tag.id"
          :label="tag.name"
          :value="tag.id">
        </el-option>
      </el-select>
      <div class="form-tip">
        最多 {{ maxTags }} 个；清空后保存表示移除该视频的全部标签。
        <span v-if="tagDialogBatch">批量操作会把所选视频的标签整体替换为这里选中的集合。</span>
      </div>
      <template slot="footer">
        <el-button type="primary" :loading="tagSubmitting" @click="submitTags">保存</el-button>
        <el-button @click="tagDialogVisible = false">取消</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import AddOrUpdate from '../movies/movies-add-or-update'
import {
  getMoviesPage,
  deleteMovies,
  deleteFrontSearchCache,
  updateMovieStatus,
  updateMovieTags,
  batchUpdateMovieTags,
  getMovieTagPage,
  mockSort,
  VIP_TYPE,
  MOVIE_STATUS,
  MAX_TAGS_PER_MOVIE
} from '@/api/movie'

export default {
  name: 'VideoManage',
  components: {
    AddOrUpdate
  },
  data () {
    return {
      loading: false,
      dataList: [],
      // 电影标签列表，供筛选和标签编辑使用
      tagList: [],
      selections: [],
      page: 1,
      limit: 10,
      total: 0,
      dataForm: {
        cartoonName: '',
        tagId: '',
        status: '',
        durationMin: '',
        durationMax: ''
      },
      dialogVisible: false,
      // 标签编辑
      tagDialogVisible: false,
      tagDialogBatch: false,
      tagDialogCode: '',
      tagDialogMovieName: '',
      tagDialogIds: [],
      tagSubmitting: false
    }
  },

  computed: {
    vipType () {
      return VIP_TYPE
    },
    maxTags () {
      return MAX_TAGS_PER_MOVIE
    },
    movieStatus () {
      return MOVIE_STATUS
    }
  },

  async created () {
    await this.loadTags()
    this.loadList()
  },

  methods: {
    loadTags () {
      return getMovieTagPage({ page: 1, limit: 200 }).then(({ data: res }) => {
        if (res.code !== 0) {
          // 标签接口挂掉时明确提示，否则会被误认为「没有标签」
          this.$message.warning(`标签列表加载失败：${res.msg || '未知错误'}`)
          return
        }
        this.tagList = (res.data && res.data.list) || []
      }).catch(() => {
        this.$message.warning('标签列表加载失败，标签筛选和标签设置暂不可用')
      })
    },

    loadList () {
      this.loading = true
      const params = {
        page: this.page,
        limit: this.limit
      }
      if (this.dataForm.cartoonName) {
        params.cartoonName = this.dataForm.cartoonName
      }
      if (this.dataForm.status !== '') {
        params.status = this.dataForm.status
      }
      // 后端按标签筛选的参数名为 tag_id
      if (this.dataForm.tagId !== '') {
        params.tag_id = this.dataForm.tagId
      }
      // 视频时长范围（分钟），后端转成秒再按 vod_duration 过滤
      if (this.dataForm.durationMin !== '' && this.dataForm.durationMin !== null) {
        params.durationMin = this.dataForm.durationMin
      }
      if (this.dataForm.durationMax !== '' && this.dataForm.durationMax !== null) {
        params.durationMax = this.dataForm.durationMax
      }

      return getMoviesPage(params).then(({ data: res }) => {
        if (res.code !== 0) {
          this.dataList = []
          this.total = 0
          return this.$message.error(res.msg)
        }
        const list = (res.data && res.data.list) || []
        this.total = (res.data && res.data.total) || 0
        this.dataList = list.map(item => ({
          ...item,
          tags: item.tags || [],
          sort: mockSort(item.cartoonCode)
        }))
      }).catch(() => {
        this.$message.error('加载视频列表失败')
      }).finally(() => {
        this.loading = false
      })
    },

    handleSearch () {
      this.page = 1
      this.loadList()
    },

    handleSizeChange (val) {
      this.limit = val
      this.page = 1
      this.loadList()
    },

    handlePageChange (val) {
      this.page = val
      this.loadList()
    },

    handleSelectionChange (val) {
      this.selections = val
    },

    addOrUpdate (cartoonCode) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.dataForm.cartoonCode = cartoonCode || ''
        this.$refs.addOrUpdate.init()
      })
    },

    // 分集功能暂时下线，恢复时同步放开操作列的「分集」按钮和路由菜单
    // handleViewEpisodes (row) {
    //   this.$router.push({ path: 'moviesinfo-moviesinfo', query: { cartoonCode: row.cartoonCode } })
    // },

    handleDelete (cartoonCode) {
      const codes = cartoonCode
        ? [cartoonCode]
        : this.selections.map(item => item.cartoonCode)
      if (!codes.length) {
        return this.$message.warning('请先选择要删除的视频')
      }
      this.$confirm(`确定删除选中的 ${codes.length} 个视频？`, '提示', {
        type: 'warning'
      }).then(() => {
        return deleteMovies(codes)
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return Promise.reject(new Error(res.msg || '删除失败'))
        }
        this.$message.success('删除成功')
        this.loadList()
      }).catch(e => {
        if (e && e.message) {
          this.$message.error(e.message)
        }
      })
    },

    isOnline (row) {
      return Number(row.status) !== MOVIE_STATUS.OFFLINE
    },

    handleToggleOnline (row) {
      const online = this.isOnline(row)
      const nextStatus = online ? MOVIE_STATUS.OFFLINE : MOVIE_STATUS.ONLINE
      this.$confirm(`确定${online ? '下架' : '上架'}「${row.cartoonName}」？`, '提示', {
        type: 'warning'
      }).then(() => {
        return updateMovieStatus(row.cartoonCode, nextStatus)
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return Promise.reject(new Error(res.msg || '操作失败'))
        }
        this.$message.success(online ? '已下架' : '已上架')
        this.loadList()
      }).catch(e => {
        if (e && e.message) {
          this.$message.error(e.message)
        }
      })
    },

    // ---------- 标签 ----------
    openTagDialog (row) {
      this.tagDialogBatch = false
      this.tagDialogCode = row.cartoonCode
      this.tagDialogMovieName = row.cartoonName
      this.tagDialogIds = (row.tags || []).map(tag => tag.id)
      this.tagDialogVisible = true
    },

    openBatchTagDialog () {
      if (!this.selections.length) {
        return this.$message.warning('请先选择视频')
      }
      if (this.selections.length > 100) {
        return this.$message.warning('批量设置标签最多支持 100 个视频')
      }
      this.tagDialogBatch = true
      this.tagDialogCode = ''
      this.tagDialogMovieName = ''
      this.tagDialogIds = []
      this.tagDialogVisible = true
    },

    submitTags () {
      this.tagSubmitting = true
      const request = this.tagDialogBatch
        ? batchUpdateMovieTags(this.selections.map(item => item.cartoonCode), this.tagDialogIds)
        : updateMovieTags(this.tagDialogCode, this.tagDialogIds)

      request.then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message.success('标签已更新')
        this.tagDialogVisible = false
        this.loadList()
        // 标签的 movieCount 会随之变化，同步刷新标签列表
        this.loadTags()
      }).catch(() => {
        this.$message.error('标签更新失败')
      }).finally(() => {
        this.tagSubmitting = false
      })
    },

    // 入口按钮暂时隐藏，恢复时放开工具栏中的注释即可
    handleClearCache () {
      this.$confirm('确定要清理用户端搜索缓存吗？', '提示', {
        type: 'warning'
      }).then(() => {
        return deleteFrontSearchCache()
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return Promise.reject(new Error(res.msg || '清理失败'))
        }
        this.$message.success('用户端缓存已清理')
      }).catch(e => {
        if (e && e.message) {
          this.$message.error(e.message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mod-video {
  background-color: #f5f7fa;
  min-height: 100%;
}

.page-header {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  background-color: #fff;
  border-bottom: 1px solid #ebeef5;

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2d3d;
  }
}

.page-body {
  padding: 16px;
}

.toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;

  &__search {
    width: 260px;
    margin-right: 12px;
  }

  &__select {
    width: 160px;
    margin-right: 12px;
  }

  &__right {
    margin-left: auto;
  }
}

.panel {
  background-color: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 0 16px 16px;

  &__tip {
    padding: 14px 0;
    font-size: 12px;
    color: #e6a23c;
  }
}

.cover {
  width: 90px;
  height: 50px;
  border-radius: 4px;
  overflow: hidden;

  &--empty {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f7fa;
    color: #c0c4cc;
    font-size: 12px;
  }
}

.title {
  color: #1f2d3d;
  line-height: 1.5;

  &__sub {
    color: #909399;
    font-size: 12px;
    margin-top: 2px;
  }
}

.tag-item {
  margin-right: 6px;
}

.tag-dialog__movie {
  margin-bottom: 12px;
  font-size: 14px;
  color: #1f2d3d;
}

.form-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
}

.danger-text {
  color: #f56c6c;
}

.pagination {
  margin-top: 16px;
  text-align: right;
}

::v-deep .el-table th {
  background-color: #fafbfc;
  color: #909399;
  font-weight: 500;
}
</style>
